<template>
  <div>
    <div class="head" v-show="showlink">
      <weitap class="weitap" :shuju="shuju" :Tapchecked="Tapchecked"></weitap>
    </div>
    <div id="wrap" class="box" v-cloak>
      <div class="header">
        <p class="title">视力调理协议书</p>
      </div>
      <div class="content">
        <div>
          <div class="line">甲方: {{ centre_list.centre }}</div>
          <div class="line">地址: {{ centre_list.site }}</div>
          <div class="information">
            <ul style="margin-right: 10px;">
              <li>
                <span>乙 &nbsp;&nbsp;&nbsp; &nbsp; 方:</span>
                <input type="text" @input="search_name(userinfo.baobao_name)" v-model="userinfo.baobao_name" placeholder="请输入会员姓名检索"/>
              </li>
              <li>
                <span>身份证号码:</span>
                <input type="text"  v-model="userinfo.id_number"/>
              </li>
              <li>
                <span>乙方监护人:</span>
                <input type="text"  v-model="userinfo.consignee_name"/>
              </li>
              <li>
                <span>身份证号码:</span>
                <input type="text"  v-model="userinfo.p_id_number"/>
              </li>
              <li style="width: 98%">
                <span>地 &nbsp;&nbsp;&nbsp; &nbsp; 址:</span>
                <input type="text" style="width: 82%"  v-model="userinfo.site"/>
              </li>
              <li>
                <span>电 &nbsp;&nbsp;&nbsp; &nbsp; 话:</span>
                <input type="text"  v-model="userinfo.consignee_phone"/>
              </li>
              <li>
                <span>邮 &nbsp;&nbsp;&nbsp; &nbsp; 箱:</span>
                <input type="text"  v-model="userinfo.email"/>
              </li>
            </ul>
          </div>
          <div style="clear: both"></div>
          <ul class="ul_list" v-show="ul_show">
            <li v-for="item in name_list" @click="confirm_name(item.user_id)" :key="item.user_id">
              <span>{{ item.baobao_name }}</span>
              <span>{{ item.baobao_name2 }}</span>
            </li>
          </ul>
          <div class="title">商品信息：</div>
          <table class="one-table"  border="1" style="margin: 20px">
            <tr class="tr">
              <td>商品名称</td>
              <td>次数</td>
              <td>单次原价</td>
              <td>原总价</td>
              <td>实收总价</td>
              <td>有效期</td>
            </tr>
            <tr>
              <td>
                <select style="width: 100%;padding: 10px" v-model="ht_goods">
                  <option style="color: #666">请选择</option>
                  <option v-for="item in goods_list" :value="item" :key="item.s_id">{{ item.s_name }}</option>
                </select>
              </td>
              <td>{{ ht_goods.k_shu }}</td>
              <td>{{ht_goods.price/ht_goods.k_shu | numFilter}}</td>
              <td>{{ ht_goods.price }}</td>
              <td>
                <input type="number"  style="width: 100%;padding: 10px;text-align:inherit" v-model="total_price" min="0"/>
              </td>
              <td>
                <input type="number"  style="width: 50%;padding: 10px;text-align:inherit" v-model="expire_month" min="0"/>个月
              </td>
            </tr>
          </table>
          <div>
            甲、乙双方经友好协商，本着自愿、平等、诚信的原则，就乙方接受甲方视力调理服务相关事宜，达成以下协议内容，以资共同遵守。<br>
            第一条 服务事项<br>
            1、甲方将根据乙方的视力情况，为其定制视力调理方案：按周期进行眼部贴敷按摩调理。<br>
            2、乙方接受调理服务前的视力状况为：（裸视力）R:<input type="text" class="input_2"  v-model="right"/>
            L:<input type="text" class="input_2"  v-model="left"/>    。<br>
            第二条 权利与义务<br>
            1、为保证视力调理效果，乙方应严格按照甲方制定的调理周期及方案接受调理服务，并配合甲方工作人员进行视力检测、评估等。<br>
            2、乙方保证向甲方如实陈述自身的视力健康状况如有散光、弱视及其他眼疾等或皮肤过敏史或其他不适症状等应书面告知甲方，因乙方隐瞒健康状况导致调理过程中出现的身体不适或调理结果不理想等，甲方不承担责任。<br>
            3、乙方应按照本协议约定的收费标准向甲方支付视力调理服务费用。<br>
            第三条服务费用<br>
            1、视力调理服务费用单次为人民币<input type="text" class="input_2" disabled  v-model="single_price"/> 元，
            共<input type="text" class="input_2" disabled  v-model="allnum"/> 次，
            实收总价为人民币：<input type="text" class="input_2" disabled :value="total_price"/> 元（大写：<input type="text" disabled class="input_2" style="width: 150px"  :value="total_price_big"/> 圆整）。
            本协议签订当日乙方将前述费用一次性支付至甲方指定账户。<br>
            2、退费条款：若乙方经过三日连续按摩调理后，视力状况无任何改善且视力表检测数据较乙方接受调理前未提升的，甲方同意退还乙方已付服务费用。若因乙方自身原因未按照甲方制定的方案连续三日接受调理服务或接受调理服务超过三次后，则乙方无权要求甲方退还服务费用。<br>
            第四条争议解决<br>
            执行本协议过程中的任何争议，双方应友好协商解决；若协商不成，任何一方均有权将争议提交至甲方所在地有管辖权的法院解决。<br>
            第五条其他<br>
            1、本协议有效期自合同签署后<input type="text" disabled class="input_2" :value="expire_month"/>个月内有效，合同有效期届满后服务项目终止。<br>
            2、本协议自双方签字盖章之日起生效，协议一式两份，甲、乙双方各执一份，具有同等法律效力。<br>
            <table>
              <tr style="height: 55px;">
                <td>甲方(盖章)：
                  <select class="sel" style="margin-top:0" v-model="staff_id">
                    <option value>请选择</option>
                    <option
                      v-for="item in staff_list"
                      :value="item.user_id"
                      :key="item.user_id"
                    >{{ item.username }}
                    </option>
                  </select>
                </td>
                <td>乙方(签字)：</td>
              </tr>
              <tr>
                <td>签署日期：
                  <el-date-picker
                    v-model="sign_date"
                    placeholder="选择日期"
                    size="small"
                    style="height: 36px"
                    type="date"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </td>
                <td>签署日期：
                  <el-date-picker
                    v-model="sign_date"
                    placeholder="选择日期"
                    size="small"
                    style="height: 36px"
                    type="date"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </td>
              </tr>
            </table>

          </div>
        </div>
      </div>

      <el-dialog title="提示" :visible.sync="dialogVisibl2" width="20%">
        <div style="padding:10px;">签约完成,请确认操作</div>
        <span slot="footer" class="dialog-footer">
                        <a
                          href="{:U('User/index')}"
                          style="padding: 4px 8px;font-size: 12px;"
                          class="btn btn-default"
                        >会员列表</a>
                        <el-button type="warning" @click="jump()">打印合同</el-button>
                    </span>
      </el-dialog>
      <div style="margin: 20px 0;text-align:center">
        <el-button
          size="medium "
          type="warning"
          round
          @click="add_con"
          :disabled="isDisabled"
        >添加合约
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import weitap from "@/components/weitap";

export default {
  components: {
    weitap
  },
  data() {
    return {
      shuju: [
        {
          lian: "huiyuan",
          neir: "会员列表"
        },
        {
          lian: "insert",
          neir: "新增会员"
        },
        {
          lian: "add_con",
          neir: "签约"
        },
      ],
      Tapchecked: 2,
      userinfo: {
        user_id: "",
        baobao_name: "",
        baobao_name2: "",
        baobao_sex: "",
        baobao_birthday: ""
      },
      ht_goods:'',
      right:'',
      left:'',
      single_price:'',
      allnum:'',
      total_price:'',
      expire_month:'',
      total_price_big:'',
      sign_date:'',
      staff_id:'',
      dialogVisibl2: false,
      isDisabled:false,
      ul_show:false,
      infant_name: "", //幼儿姓名
      goods_list: [], //商品信息列表
      name_list: [], //姓名
      vip: "", //会员卡号
      dindan: "", //收据号
      centre_list: "", //中心
      parent_list: "", //父母资料
      staff_list:'',
      now_name_index:"",
      showlink: true,
      type_link: "",
      is_change: false,
      jl_id:'',
    };
  },
  mounted() {
    let that = this;
    this.token = $.cookie("token");
    this.get_goods();
    this.get_staff();
    //判断是否由添加会员点击签约
    var uid = this.$route.query.id;
    if (uid) {
      //如果存在
      this.now_name_index = 0;
      this.confirm_name(uid);
    }
    this.type_link = this.$route.query.type;
    if (this.type_link == 2 || this.type_link == 3) {
      this.showlink = false;
    }
  },
  methods:{
    //点击添加合同
    add_con(){
      if (!this.userinfo.user_id) {
        this.$message({message: "请选择签约会员", type: "error"});
        return false;
      }
      if (!this.ht_goods) {
        this.$message({message: "请选择商品信息", type: "error"});
        return false;
      }
      if (!this.total_price) {
        this.$message({message: "请输入实收总价", type: "error"});
        return false;
      }
      if (!this.expire_month) {
        this.$message({message: "请输入有效期", type: "error"});
        return false;
      }
      if (!this.right || !this.left) {
        this.$message({message: "请输入裸视力", type: "error"});
        return false;
      }
      if (!this.sign_date) {
        this.$message({message: "请选择签署日期", type: "error"});
        return false;
      }
      if (!this.staff_id) {
        this.$message({message: "请选择销售人员(甲方)", type: "error"});
        return false;
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let that = this;

      $.ajax({
        url: process.env.apiUrl + "saas/User/add_eye_con",
        type: "post",
        data: {
          token: that.token,
          users: that.userinfo,
          s_id: that.ht_goods.s_id,
          sign_date: that.sign_date,
          expire_month: that.expire_month,
          receivable: that.ht_goods.price,
          shishou: that.total_price,
          shishou_a: that.total_price_big,
          staff_id: that.staff_id,
          allnum: that.allnum,
          single_price: that.single_price,
          left: that.left,
          right: that.right
        },
        success: function (res) {
          loading.close();
          if (res.status == 1) {
            that.isDisabled = true;
            that.$message({
              message: res.msg,
              type: "success",
              duration: 1000
            });

            that.jl_id = res.jl_id;
            //显示打印合约窗口
            setTimeout(that.jump(), 2000);
          } else {
            that.$message({
              message: res.msg,
              type: "error"
            });
          }
        },
        error: function (err, status) {
          loading.close();
        },
        complete: function () {
          loading.close();
        }
      });
    },
    //跳转打印页面
    jump() {
      let self = this;
      self.$router.push({
        name: "show_con",
        query: {
          id: self.jl_id,
          type: self.type_link
        }
      });
    },
    //获取商品信息列表
    get_goods(){
      let that = this;
      $.ajax({
        url: process.env.apiUrl + "saas/user/get_ksb",
        type: "post",
        data: {
          token: that.token
        },
        success: function (data, status) {
          if (data.status == 1) {
            that.goods_list = data.data;
          }
        },
        fail: function (err, status) {
          console.log(err);
        }
      });
    },
    //获取员工信息
    get_staff(){
      let that = this;
      $.ajax({
        url: process.env.apiUrl + "saas/User/allstaff",
        type: "post",
        data: {
          token: that.token
        },
        success: function (res) {
          that.staff_list = res.data;
        },
      });
    },
    //按姓名搜索
    search_name(name) {
      this.ul_show = true;

      let that = this;
      $.ajax({
        url: process.env.apiUrl + "saas/user/search_name",
        type: "post",
        data: {
          token: that.token,
          search: name
        },
        success: function (res) {
          if (res.status == 1) {
            that.name_list = res.data;
          }
        },
        fail: function (err) {
          console.log(err);
        }
      });
    },
    //查询详情
    confirm_name(uid){
      this.ul_show = false;
      let that = this;
      $.ajax({
        url: process.env.apiUrl + "saas/user/search_details",
        type: "post",
        data: {
          token: that.token,
          user_id: uid
        },
        success: function (res, status) {
          if (res.status == 1) {
            that.centre_list = res.centre_info;
            that.userinfo = res.user_info;
            if (res.user_info.vip > 0 && res.user_info.kahao) {
              that.is_vip = true;
              that.vip = res.user_info.kahao;
              if (that.vip) {
                that.is_change = true;
              }
            }
          } else {
            that.centre_list = "";
            that.parent_list = "";
            that.vip = "";
            that.userinfo =
              {
                user_id: "",
                baobao_name: "",
                baobao_name2: "",
                baobao_sex: "",
                baobao_birthday: ""
              }

            that.$message({
              message: data.msg,
              type: "error"
            });
          }
        },
        fail: function (err, status) {
          console.log(err);
        }
      });
    },
    //转大写
    convertCurrency(money) {
      //汉字的数字
      var cnNums = ["零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖"];
      //基本单位
      var cnIntRadice = ["", "拾", "佰", "仟"];
      //对应整数部分扩展单位
      var cnIntUnits = ["", "万", "亿", "兆"];
      //对应小数部分单位
      var cnDecUnits = ["角", "分", "毫", "厘"];
      //整数金额时后面跟的字符
      var cnInteger = "整";
      //整型完以后的单位
      var cnIntLast = "元";
      //最大处理的数字
      var maxNum = 999999999999999.9999;
      //金额整数部分
      var integerNum;
      //金额小数部分
      var decimalNum;
      //输出的中文金额字符串
      var chineseStr = "";
      //分离金额后用的数组，预定义
      var parts;
      if (money == "") {
        return "";
      }
      money = parseFloat(money);
      if (money >= maxNum) {
        //超出最大处理数字
        return "";
      }
      if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }
      //转换为字符串
      money = money.toString();
      if (money.indexOf(".") == -1) {
        integerNum = money;
        decimalNum = "";
      } else {
        parts = money.split(".");
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }
      //获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
          var n = integerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            //归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }
      //小数部分
      if (decimalNum != "") {
        var decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
          var n = decimalNum.substr(i, 1);
          if (n != "0") {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (chineseStr == "") {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum == "") {
        chineseStr += cnInteger;
      }
      return chineseStr;
    },
  },
  watch:{
    total_price(){
      this.allnum = this.ht_goods.k_shu
      this.single_price = Number(this.total_price)/Number(this.allnum)
      this.single_price = parseFloat(this.single_price).toFixed(2)
      this.total_price_big = this.convertCurrency(Number(this.total_price))
    }
  },
  filters: {
    numFilter(value) {
      if (value) {
        // 截取当前数据到小数点后两位
        let realVal = parseFloat(value).toFixed(2)
        return realVal
      } else {
        return 0
      }
    }
  },
  computed: {

  }
};
</script>

<style scoped>
* {
  font-size: 12px;
  margin: 0;
  padding: 0;
}

[v-cloak] {
  display: none;
}

input:disabled {
  background: #fff;
  cursor: no-drop;
}
.input_2{
  width: 80px;
  border: 0;
  border-bottom: 1px solid;
  margin: 0px 5px;
  padding:0px 10px;
}
.head {
  padding: 10px 45px 0;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  border-bottom: 1px solid #bdb8e0;
}

li {
  list-style: none;
}

body {
  margin: 30px 40px;
}

#wrap {
  width: 210mm;
  height: 294mm;
  padding: 15px 30px;
  box-sizing: border-box;
}

.header .title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.header .right {
  display: inline-block;
  font-weight: bold;
  font-size: 18px;
  float: right;
}

.small-title span {
  display: inline-block;
  margin-top: 58px;
  margin-left: 5px;
  margin-bottom: 14px;
}

.small-title ul {
  float: right;
  margin-right: 3px;
}

.small-title input {
  border: 0;
  border-bottom: 1px solid;
  outline: none;
  width: 112px;
  text-align: center;
}

.information {
  margin-left: 6px;
}

.information ul {
  width: 98%;
  display: inline-block;
}

.information li {
  width: 48%;
  margin-top: 9px;
  float: left;
}

.information input {
  border: 0;
  border-bottom: 1px solid;
  outline: none;
  padding-left: 11px;
  width: 220px;
}

.information li span {
  letter-spacing: 2px;
}

.infant {
  margin-left: 5px;
}

.infant .n_input {
  border: 0;
  border-bottom: 1px solid;
  outline: none;
  padding-left: 11px;
  width: 60px;
}

.infant .t_input {
  border: 0;
  border-bottom: 1px solid;
  outline: none;
  padding-left: 11px;
  width: 30px;
}

.infant .add {
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 13px;
  text-align: center;
  border: 1px solid black;
  border-radius: 50%;
  cursor: pointer;
}

.ze-table tr td {
  border: 1px solid #000000;
}

.infant label {
  margin-left: 25px;
}

.infant input {
  vertical-align: middle;
}

.infant .title {
  margin: 13px 0 5px 0;
  font-weight: bold;
}

.ul_list {
  position: absolute;
  background-color: rgb(255, 255, 255);
  z-index: 999;
  border: 1px solid gray;
  padding: 3px 10px 8px;
  width: 300px;
  text-align: center;
  margin-top: -90px;
  margin-left: 40px;
}

.ul_list li {
  display: flex;
}

.ul_list li:nth-child(2n-1) {
  background: #f7f8f9;
}

.ul_list li span {
  float: left;
  cursor: pointer;
  width: 50%;
  line-height: 40px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.content {
  margin-left: 5px;
}

.content .line {
  margin-top: 5px;
  margin-left: 5px;
}

.content .title {
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 5px;
}

.one-table {
  text-align: center;
}

.content table {
  width: 100%;
}

.content .one-table td {
  text-align: center;
}

.one-table .tr td {
  width: 12%;
  padding: 8px 0;
}

.content .sel {
  margin-top: 20px;
  padding-left: 5px;
  padding-right: 30px;
}

.content .two-table div {
  padding: 10px 0 10px 15px;
  border-top: 1px solid black;
}

.content .two-table textarea {
  margin-left: 14px;
  width: 92%;
  height: 58px;
  margin-top: 24px;
  padding: 6px 10px;
  box-sizing: border-box;
  outline: none;
}

.content div:first-child {
  border: 0;
}

.three-table td,
th {
  text-align: center;
  padding: 8px 0;
}

.close_btn {
  margin-left: 11px;
  position: relative;
  border: 1px solid gray;
  border-radius: 2px;
  padding: 4px 15px 4px 5px;
}

.close_btn span {
  position: absolute;
  top: 0;
  right: 3px;
  cursor: pointer;
}

.dialog-type {
  min-height: 150px;
}

.dialog-type .lagbox1 {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #E6BE8A;
  text-align: center;
  color: #fff;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 130px;
}

.el-input--prefix .el-input__inner {
  border-color: gainsboro;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: gainsboro;
  background: gray;
}

.el-radio__input.is-checked + .el-radio__label {
  color: black;
}

.el-dialog__header {
  display: none;
}

.dia_header {
  padding: 12px 12px 12px 30px;
  background: #E6BE8A;
  position: relative;
}

.search_inp {
  height: 24px;
  margin-left: 30px;
  padding-left: 10px;
  outline: none;
  border: 1px solid gray;
  border-radius: 2px;
  margin-right: 5px;
}

.search_sel {
  height: 26px;
  padding-right: 10px;
  padding-left: 5px;
}

.el-input-number--mini {
  width: 100px;
}

.el_close {
  color: rgb(255, 255, 255);
  font-size: 24px;
  float: right;
  padding-right: 18px;
  cursor: pointer;
}

.el-pager li.active {
  color: gray;
}

.el-pager li:hover {
  color: gray;
}

.input_num {
  width: 60px;
  height: 23px;
  text-align: center;
  border: 1px solid grey;
  border-radius: 3px;
}

.el-table td,
.el-table th {
  padding: 6px 0;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: gainsboro;
  border-color: gray;
}

input:focus:invalid,
textarea:focus:invalid {
  box-shadow: none;
}

.huiTap {
  width: 100%;
  padding-left: 32px;
  padding-right: 54px;
  height: 50px;
  border-bottom: 1px solid #dbdbdb;
}

.huiList {
  padding-top: 10px;
  width: 500px;
  float: left;
}

.huiList li {
  width: 93px;
  height: 39px;
  line-height: 39px;
  float: left;
  text-align: center;
  overflow: hidden;
  border-top: 1px solid #E6BE8A;
  border-left: 1px solid #E6BE8A;
  border-right: 1px solid #E6BE8A;
  border-radius: 8px 8px 0 0;
  margin-right: 15px;
}

.huiList li a {
  display: block;
  width: 100%;
  height: 100%;
  background: #E6BE8A;
  color: #fff;
}

.huiList li a.active {
  background: #edebff;
  color: #E6BE8A;
}

.el-input__prefix {
  display: none;
}

.el-input--prefix .el-input__inner {
  padding-left: 0;
}

.radios {
  margin-left: 0;
  padding-left: 30px;
  padding-bottom: 20px;
}

.table-tit {
  display: inline-block;
  width: 50px;
  text-align: justify;
  text-align-last: justify;
  text-justify: distribute-all-lines;
}
</style>
<style lang="less">
#newdia .el-dialog__body {
  position: relative;
  padding: 0;
}

#newdia .gift {
  .el-dialog__header {
    display: none !important
  }

  .el-button {
    padding: 5px 20px !important;
  }
}

#wrap {
  padding-right: 10px;

  .el-tag {
    position: relative;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .el-tag__close {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 1px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/huiyuan/add_con.vue